<div class="edit_profile">
  <slotcom-h2 text="{{ 'home.profile.nickName.title' | translate }}"></slotcom-h2>

  <slotcom-navigation-button
    type="close"
    width="3"
    height="3"
    topPosition="-1"
    rightPosition="-1"
    (click)="close()">
  </slotcom-navigation-button>
</div>
<hr class="c-divider" />
<form>
  <div class="c-field">
    <input
      class="c-field__input"
      id="current"
      type="text"
      maxlength="16"
      [formControl]="current" />
    @if (!current.value) {
      <label class="c-field__label">{{ 'home.profile.nickName.text' | translate }}</label>
    }
    <div class="c-field__line"></div>
    <div class="c-field__subscript">
      @if (current.invalid && current.touched && current.errors.required) {
        <span class="c-field__error">{{ 'home.profile.fieldRequired' | translate }}</span>
      } @else if (current.invalid && current.touched && current.errors.minlength) {
        <span class="c-field__error">{{ 'home.profile.minLength' | translate }}</span>
      } @else if (current.invalid && current.touched && current.errors.maxlength) {
        <span class="c-field__error">Max user name length reached</span>
      } @else if (current.invalid && current.touched && current.errors.pattern) {
        <span class="c-field__error">{{ 'home.profile.whiteSpaces' | translate }}</span>
      } @else if (current.invalid && current.touched && current.errors.sameUserName) {
        <span class="c-field__error">{{ 'home.profile.sameName' | translate }}</span>
      } @else if (current.invalid && current.touched && current.errors.emojis) {
        <span class="c-field__error">{{ 'home.profile.invalidCharacters' | translate }}</span>
      } @else if (current.invalid && current.touched && current.errors.userExist) {
        <span class="c-field__error">{{ 'home.profile.alreadyExists' | translate }}</span>
      }
      <span class="c-field__hint">{{ current.value?.length || 0 }}/16</span>
    </div>
  </div>

  <slotcom-button
    [isDisabled]="current.invalid"
    (safeClick)="onSubmit()"
    audioType="functionality"
    class="c-button--pink small">
    {{ 'home.profile.nickName.button' | translate }}
  </slotcom-button>
  <slotcom-p
    class="text-center mt-2"
    text="{{ 'home.profile.nickName.notice' | translate }}"></slotcom-p>
</form>
